/**
 * popover.js
 */

import React from 'react';
import { Popover as MuiPopover } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import usePrevious from 'utils/use-previous';
import Icon from 'components/icon';


const useStyles = makeStyles(theme => ({
  arrow: {
    transition: '150ms ease-in-out',
    '&.open': {
      transform: 'rotateZ(180deg)'
    }
  }
}));


export default function Popover(props) {
  const {
    id,
    label,
    children,
    closeOnClick,
    onOpen: onOpenProp,
    onClose: onCloseProp,
    anchorOrigin,
    transformOrigin,
    triggerClose,
    openEventName = 'onClick',
    closeEventName,
    ...rest
  } = props;
  const classes = useStyles(props);
  const popoverId = 'popover-' + id;
  const [anchor, setAnchor] = React.useState();
  const prevTriggerClose = usePrevious(triggerClose);


  const onOpen = (event) => {
    event.preventDefault();
    // currentTarget is null outside an event handler, e.g. if async. Assume target in that case.
    setAnchor(event.currentTarget || event.target);
    if (onOpenProp) {
      onOpenProp();
    }
  }


  const onClose = React.useCallback((event) => {
    event && event.stopPropagation();
    setAnchor(null);
    if (onCloseProp) {
      onCloseProp();
    }
  }, [onCloseProp])


  React.useEffect(() => {
    if (triggerClose !== undefined && prevTriggerClose !== undefined && triggerClose !== prevTriggerClose) {
      onClose();
    }
  }, [triggerClose, prevTriggerClose, onClose]);


  const arrowIcon = (
    <Icon 
      fontSize='small' 
      type='arrow-down' 
      className={`${classes.arrow} ${Boolean(anchor) ? 'open' : ''}`} 
    />
  );


  // add attributes required for this menu's button
  const newLabel = (
    typeof(label) === 'function' 
      ? label(Boolean(anchor), onOpen, arrowIcon) 
      : React.Children.map(label, child => {
        const newProps = {
          'aria-label': props['aria-label'],
          'aria-controls': popoverId,
          'aria-haspopup': true,
          [openEventName]: onOpen,
        };
        if (closeEventName) {
          newProps[closeEventName] = onClose;
        }
        return React.cloneElement(child, newProps);
      })
  );


  return (
    <>
      {newLabel}

      <MuiPopover
        id={popoverId}
        open={Boolean(anchor)}
        onClose={onClose}
        onClick={closeOnClick ? onClose : () => {}}
        anchorEl={anchor}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        {...rest}
      >
        {children}
      </MuiPopover>
    </>
  );
}